define(
	'C3.ShoppingExtensions.PDP.MakeAnOffer.Model',
	[
		'SCModel',
		'Utils'
	],
	function(SCModelComponent, Utils){
		'use strict';

		var SCModel = SCModelComponent.SCModel;

		function MakeAnOfferModel() {
			SCModel.call(this);

			// Define properties of the model.
			this.urlRoot = function() {
				return Utils.getAbsoluteUrl(
					getExtensionAssetsPath("services/MakeAnOffer.Service.ss")
				)
			}

			this.validation = function (){
				return {
						firstname: {
		                required: true,
		                msg: Utils.translate('First Name is Required')
		           		 },
			            lastname: {
			                required: true,
			                msg: Utils.translate('Last Name is Required')
			            },
			            email: [
			                {
			                    required: true,
			                    msg: 'Email Address is Required'
			                },
			                {
			                    pattern: 'email',
			                    msg: 'Valid email address is required'
			                }
			            ],
			            company: {
			                required: true,
			                msg: Utils.translate('Company is Required')
			            },
			            offeramount: [
			                {
			                    required: true,
			                    msg: 'Offer Amount is Required'
			                },
			                {
			                    pattern: 'number',
			                    msg: 'Only numeric value is accepted'
			                }
			            ],
			            phone: [
			                {
			                    required: true,
                				fn: Utils.validatePhone
			                }/*,
			                {
			                    pattern: 'number',
			                    minLength: 7,
			                    msg: 'Valid phone number is required'
			                }*/
			            ],
			            language: {
			                fn: function(val) {
			                   if(val == 'Select one*' || val == undefined)
			                    return Utils.translate('Language is Required');
			                }
			            },
			            country: {
			                fn: function(val) {
			                  // console.log(val)
			                   if(val == 'Select one*' || val == undefined)
			                    return Utils.translate('Country is Required');
			                }
			            },
			            state: {
			                 fn: function(value,name,form) {
			                   //console.log(form)

			                   if(form.country == "United States" && (form.state == undefined || form.state == 'Select one*'))
			                    return Utils.translate('State is Required');                  
			                }
			            },
			            ima: {
			                 fn: function(val) {
			                   // console.log(val)
			                    if(val == 'Select one*' || val == undefined)
			                    return Utils.translate('Category is Required');
			                   
			                }
			            }
				}
			}
		}

		MakeAnOfferModel.prototype = Object.create(SCModel.prototype);

		MakeAnOfferModel.prototype.constructor = MakeAnOfferModel;

		// Return the AMD constructor.
		return MakeAnOfferModel;
	}
);
